module.exports = __webpack_public_path__ + "assets/images/animations/ministerioconsumo-animation.webp?e90942b8";